
export function triggerEventConfig() {
  return {
    restrict: 'E',
    template: require('./trigger-event-config.directive.html'),
    scope: {
      triggerEvent: '=',
      dropdownItems: '=',
      readonly: '<'
    },
    controller: controller
  };
}

controller.$inject = ['$scope', '$translate'];
function controller($scope, $translate) {
  init();


  function computeHoursDropdownItems() {    
    $scope.hoursItems = [];

    // 15min 30min 45min
    [15, 30, 45].map(minutes => 
      $scope.hoursItems.push({
        'id': minutes/60,
        'label': minutes + " " + $translate.instant('triage_config/trigger_events/delay/unit-minutes'),
      }));

    // 1h 2h 3h 4h 5h 6h 8h 10h 12h 15h 20h 23h 24h 25h 36h 
    [1, 2, 3, 4, 5, 6, 8, 10, 12, 15, 20, 23, 24, 25, 36].map(hours => 
      $scope.hoursItems.push({
        'id': hours,
        'label': hours + " " + $translate.instant('triage_config/trigger_events/delay/unit-hours'),
      }));

    // 2d 3d 4d 5d 6d 7d 14d
    [48, 72, 96, 120, 144, 168, 336].map(hours => 
      $scope.hoursItems.push({
        'id': hours,
        'label': hours/24 + " " + $translate.instant('triage_config/trigger_events/delay/unit-days'),
      }));
    if (!$scope.triggerEvent.isTypeParentPublicationOlderThan()) {
      // 30d, 60d, 90d
      [720, 1440, 2160].map(hours => 
        $scope.hoursItems.push({
          'id': hours,
          'label': hours/24 + " " + $translate.instant('triage_config/trigger_events/delay/unit-days'),
        }));
    }      
  }

  function init() {
    computeHoursDropdownItems();
  }
} 


